// extracted by mini-css-extract-plugin
export default {"imgSlide":"ImageSlide_imgSlide__1MKvN"};